
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavyRainShowersPolartwilightColour as ObiLightningHeavyRainShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-rain-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiLightningHeavyRainShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-rain-showers-polartwilight-colour',
   elementClass: ObiLightningHeavyRainShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 